import { Tooltip, Typography } from '@mui/material'
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl'
import DrawIcon from '@mui/icons-material/Draw'
import DetailsIcon from '@mui/icons-material/Details'
import CommentIcon from '@mui/icons-material/Comment'
import EditIcon from '@mui/icons-material/Edit'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import TimelineIcon from '@mui/icons-material/Timeline'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React from 'react'

const TooltipIcon = ({ title }: { title: string }) => (
  <Tooltip title={<Typography>{title}</Typography>} placement={'right'} enterDelay={300} arrow>
    <span>
      {(title === 'Details' || title === 'Main') && (
        <DetailsIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
      )}
      {title === 'Checklist' && (
        <ChecklistRtlIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
      )}
      {title === 'Description' && <DrawIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />}
      {title === 'Comments' && <CommentIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />}
      {title === 'Timeline' && <TimelineIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />}
      {title === 'Edit Task' && (
        <EditIcon
          sx={{
            color: 'text.warning',
            height: 22,
            width: 22,
          }}
        />
      )}
      {title === 'Save' && <CheckCircleOutlineIcon sx={{ color: 'text.success', height: 22, width: 22 }} />}
      {title === 'Save Chklist' && <FactCheckIcon sx={{ color: 'text.success', height: 22, width: 22 }} />}
      {title === 'Cancel' && <DoDisturbIcon sx={{ color: 'text.error', height: 22, width: 22 }} />}
      {title === 'Previous Task' && (
        <ChevronLeftIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
      )}
      {title === 'Next Task' && (
        <ChevronRightIcon sx={{ '&:hover': { color: 'text.highlight' }, height: 22, width: 22 }} />
      )}
    </span>
  </Tooltip>
)

export default TooltipIcon
